import { useId } from 'react';

export const AirwallexIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  const id = useId();
  const grad = `${id}-grad`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M16.9303 8.94152C16.3932 8.41754 15.6438 8.26784 14.9569 8.55478L11.8596 9.81482L8.48743 5.78518C8.00034 5.19882 7.25098 4.92436 6.50162 5.04911C5.75226 5.18635 5.14028 5.68537 4.878 6.40896L2.61742 12.4971C2.31768 13.2955 2.60493 14.2063 3.32932 14.6803C3.84138 15.0172 4.49083 15.0546 5.05285 14.83L8.11275 13.5825C8.62481 13.3704 8.91207 12.7965 8.73722 12.2725C8.54988 11.6986 7.91292 11.3992 7.36339 11.6238L5.04036 12.5844C4.94045 12.6218 4.82804 12.522 4.86551 12.4222L6.77639 7.26978C6.81385 7.18245 6.93875 7.1575 7.00119 7.23236L12.8712 14.2437C13.2709 14.7178 13.8454 14.9797 14.4449 14.9797C14.5822 14.9797 14.7071 14.9673 14.8445 14.9423C15.5689 14.8051 16.1559 14.2686 16.4057 13.57L17.3799 10.9127C17.6421 10.214 17.4673 9.45302 16.9303 8.94152ZM15.1443 10.9626L14.5073 12.6842C14.4698 12.784 14.345 12.7965 14.2825 12.7217L13.2584 11.499L14.9694 10.8004C15.0818 10.7505 15.1942 10.8503 15.1443 10.9626Z"
        fill={`url(#${grad})`}
      />
      <defs>
        <linearGradient id={grad} x1="2.50502" y1="10.0043" x2="17.505" y2="10.0043" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EF4749" />
          <stop offset="1" stopColor="#F68D41" />
        </linearGradient>
      </defs>
    </svg>
  );
};
